import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import moment from "moment";

export const exportMantenimientoToExcel = (data, inmuebles, staff, fileName = "mantenimiento.xlsx") => {
    if (!data || data.length === 0) {
        alert("No hay datos para exportar");
        return;
    }

    const getInmuebleName = (id) => {
        const inmueble = inmuebles?.find(im => im.id === id);
        return inmueble ? inmueble.name : "Desconocido";
    };

    const getStaffName = (id) => {
        const empleado = staff?.find(s => s.id === id);
        return empleado ? empleado.name : "Sin asignar";
    };

    const exportData = data.map(m => ({
        Inmueble: getInmuebleName(m.propertieId),
        Servicio: m.description,
        Estatus: m.status,
        Responsable: getStaffName(m.staffId),
        "Fecha del servicio": m.date_service
            ? moment(m.date_service).format("YYYY-MM-DD")
            : "",
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);

    ws['!cols'] = [
        { wch: 25 },
        { wch: 40 },
        { wch: 15 },
        { wch: 25 },
        { wch: 20 },
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Mantenimiento");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(dataBlob, fileName);
};
